import { useHasPermissionSync } from "@/hooks/usePermissions";
import { useRole } from "@/hooks/useRole";
import { useIsVeterinarian } from "@/hooks/useIsVeterinarian";
import { useProfile } from "@/hooks/useProfile";

/**
 * True when the current user can start a patient attendance: has permission
 * to create medical records, is a veterinarian (by role or the isVeterinarian
 * flag), and has a CRMV registered on their profile.
 */
export function useCanStartAttendance(): boolean {
  const { hasPermission: canCreateMedicalRecord } = useHasPermissionSync("medical_records", "create");
  const { data: role } = useRole();
  const { data: isVeterinarian } = useIsVeterinarian();
  const { data: profile } = useProfile();

  const hasCRMV = Boolean(
    profile?.crmv_state &&
    profile.crmv_state.trim() !== "" &&
    profile.crmv_number &&
    profile.crmv_number > 0,
  );

  return Boolean(canCreateMedicalRecord) && (role === "veterinarian" || Boolean(isVeterinarian)) && hasCRMV;
}
